import React from "react";
import { Container, Row, Col } from "react-bootstrap";
// import PlayVideo from "../Play/PlayVideo";
import gql from "graphql-tag"
import { useQuery } from '@apollo/client';
import Accordion from "react-bootstrap/Accordion"
import HTMLReactParser from 'html-react-parser';

import CTABtnModule from "../../modules/cta_btn_module";
import ContentModule from "../../modules/content_module";
import ImageModule from "../../modules/image_module";


import "./LocalExperience.scss";

const LocalExperienceOffice = ({Module, GQLPage, office_template}) => {

    var imagename = office_template ? "office.video_section_image.video_image" : "pages.video_section_image.video_image";

    let processedImages = JSON.stringify({});
    if (GQLPage?.imagetransforms?.video_section_image_Transforms) {
        processedImages = GQLPage?.imagetransforms?.video_section_image_Transforms;
    }

    return (
        <React.Fragment>
            <section className={`local-experience ${Module?.local_padd} ${Module?.title ? Module?.title.toLowerCase().replace(/ /g, '_') : ""} ${Module?.background_color} ${Module.image_align}`}>
                <Container>
                    <Row>
                        <Col>
                            <div className="local-experience-wrapper">    
                                <div className={`video-img`}>
                                    {Module?.image?.url && 
                                        <ImageModule ImageSrc={Module.image} altText={Module?.title} imagetransforms={processedImages} ggfx_results={GQLPage?.ggfx_results} renderer="srcSet" imagename={imagename} strapi_id={GQLPage?.id} /> 
                                    }
                                </div>

                                <div className="video-content">
                                    <h3>{Module?.title}</h3>
                                    
                                    {Module?.content && <ContentModule Content={Module?.content} /> }

                                    {Module?.accordian_module?.length > 0 &&
                                    <section className={`accordion-wrapper`}>
                                        <div className="accordion-section">
                                        <Accordion>
                                            {
                                                Module.accordian_module.map((item, index) => {
                                                    return(
                                                        <Accordion.Item eventKey={index.toString()}>
                                                            <Accordion.Header>{item.question}</Accordion.Header>
                                                            <Accordion.Body>
                                                                {item.answer && HTMLReactParser(item.answer)}
                                                            </Accordion.Body>
                                                        </Accordion.Item>
                                                    )
                                                })
                                            }
                                        </Accordion>
                                        </div>
                                    </section>
                                    }

                                    {Module?.button_cta && <CTABtnModule button_cta={Module.button_cta} /> }
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};
export default LocalExperienceOffice;
